import { render, staticRenderFns } from "./import-data-validation-tmc-page.vue?vue&type=template&id=2dd9a2d8&scoped=true"
import script from "./import-data-validation-tmc-page.vue?vue&type=script&lang=js"
export * from "./import-data-validation-tmc-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd9a2d8",
  null
  
)

export default component.exports